<template>
  <BreadCrumb PageTitle=" Liste des activités"/>
    <ListeActivite />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeActivite from "@/components/Activite/ListeActivite.vue";

  
    export default defineComponent({
      name: "ListeActivitePage",
      components: {
        ListeActivite,
      },
    });
  </script>